export default "__VITE_ASSET__9925dbff__"